export default {
  shade400: '#CFD6DE',
  shade10: '#bebebe',
  shade09: '#7F8C90',
  shade08: '#FFFFFF',
  shade07: '#F8F9FA',
  shade06: '#EBEEEF',
  shade05: '#CDDADE',
  shade04: '#A3AFB3',
  shade03: '#A3AFB3',
  shade02: '#424A4C',
  shade01: '#2D3132',
  shade01Rgb: '45, 49, 50',
  greenLight: '#82B9AA',
  green: '#007F68',
  yellow: '#FBB252',
  blueLight: '#587BBD',
  redLight: '#F26A5B',
  redLight1: '#FFB2A0',
  orange: '#FC7655',
  violet: '#6C52A2',
  violetRgb: '108, 82, 162',
  blueRgb: '88, 123, 189',
  violetLight: '#6958A6',
  blue1: '#455FF4',
  blue: '#5B75B9',
  error: '#B95656',
  success: '#55AD7B',
  warning: '#CFB161',
  linear01: '#F7A164',
  linear02: '#CFC345',
  linear03: '#50C487',
  linear04: '#4096AC',
  linear05: '#7452BB',
  linear06: '#BA3262',
  link: '#1e4b75', // todo - clarify
};
